import { NavLink, Outlet } from "react-router-dom";
import {
  Bot, Database, Gauge, LogOut, Send, Settings, Users,
} from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", label: "Visão geral", icon: Gauge },
  { to: "/bot", label: "Bot", icon: Bot },
  { to: "/perfis", label: "Perfis", icon: Users },
  { to: "/pool", label: "Pool", icon: Database },
  { to: "/envio-apis", label: "Envio APIs", icon: Send },
  { to: "/configuracoes", label: "Configurações", icon: Settings },
];

const NavItems = ({ mobile = false }) => items.map(({ to, label, icon: Icon }) => (
  <NavLink
    key={to}
    to={to}
    end={to === "/"}
    data-testid={`${mobile ? "mobile" : "desktop"}-nav-${label.toLowerCase().replaceAll("ç", "c").replaceAll("õ", "o").replace(" ", "-")}`}
    className={({ isActive }) => `nav-item ${mobile ? "nav-item-mobile" : ""} ${isActive ? "active" : ""}`}
  >
    <Icon size={mobile ? 20 : 18} strokeWidth={1.8} aria-hidden="true" />
    <span data-testid={`${mobile ? "mobile" : "desktop"}-nav-label-${to === "/" ? "dashboard" : to.slice(1)}`}>{label}</span>
  </NavLink>
));

export default function AppShell() {
  const { user, logout } = useAuth();
  const handleLogout = () => {
    toast.warning("Você será desconectado do painel.");
    window.setTimeout(() => logout(), 500);
  };
  return (
    <div className="app-shell">
      <aside className="sidebar" data-testid="desktop-sidebar">
        <div className="brand" data-testid="app-brand">
          <strong>Bot full</strong>
        </div>
        <nav className="sidebar-nav" data-testid="desktop-navigation"><NavItems /></nav>
        <div className="sidebar-footer">
          <div className="admin-id" data-testid="logged-admin-email">
            <span>Administrador</span><strong>{user?.email}</strong>
          </div>
          <button className="logout-button" onClick={handleLogout} data-testid="logout-button">
            <LogOut size={17} /> Sair
          </button>
        </div>
      </aside>
      <main className="main-content" data-testid="main-content"><Outlet /></main>
      <nav className="bottom-nav" data-testid="mobile-bottom-navigation"><NavItems mobile /></nav>
    </div>
  );
}